export default __webpack_public_path__ + "static/media/snehal-pic-3.17202efd.png";